<template>
  <v-card>
    <v-card-title :class="variant === 'extensive' ? 'text-h6' : ''">
      {{ locationName }}
    </v-card-title>
    <v-card-text>
      <template v-if="variant === 'compact'">
        <div
          v-for="(chunk, index) in metricChunks"
          :key="index"
          :class="['metric-row', { 'mt-3': index > 0 }]">
          <div
            v-for="metric in chunk"
            :key="metric.key"
            class="metric-cell">
            <MetricCardDisplay
              :config="metric.config"
              :is-loading="metric.value.isLoading"
              :sub-value="metric.value.subAmount"
              :target="metric.value.target"
              :value="metric.value.amount"
              :variant="variant" />
          </div>
        </div>
      </template>
      <div
        v-else
        class="metric-grid">
        <div
          v-for="metric in metrics"
          :key="metric.key"
          class="metric-item">
          <MetricCardDisplay
            :config="metric.config"
            :is-loading="metric.value.isLoading"
            :sub-value="metric.value.subAmount"
            :target="metric.value.target"
            :value="metric.value.amount"
            :variant="variant" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { MetricCardProps } from '@/models/metricDefinitions';
import { groupBySizes } from '@/utils/grouping';
import MetricCardDisplay from './MetricCardDisplay.vue';

interface Props extends MetricCardProps {
  variant?: 'compact' | 'extensive';
  rowSizes?: number[];
}

const { locationName, metrics, variant = 'compact', rowSizes } = defineProps<Props>();

const metricChunks = computed(() => groupBySizes(metrics, rowSizes));
</script>

<style scoped>
.metric-grid {
  display: grid;
  gap: 24px;
}

/* Fixed columns instead of content-sized ones, so the icons line up across every row of the card. */
.metric-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: center;
}

.metric-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
</style>
